import { toast, useErrorMessage } from '@sentinel/web-core';
import type { OrganizationProvision } from '@sentinel/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { consoleEndpoints } from '@/api/endpoints';
import { keys } from '@/api/keys';

/** Every organization of the platform, and the creation of a new one. */
export function useOrganizations() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const errorMessage = useErrorMessage();
  const list = useQuery({ queryKey: keys.organizations, queryFn: consoleEndpoints.organizations });
  const provision = useMutation({
    mutationFn: (input: OrganizationProvision) => consoleEndpoints.provision(input),
    onSuccess: (created) => {
      toast(
        'ok',
        t('console.organizations.created', { name: created.name }),
        t('console.organizations.createdDetail'),
      );
      void queryClient.invalidateQueries({ queryKey: keys.organizations });
    },
    onError: (error) => toast('att', errorMessage(error)),
  });
  return { list, provision };
}
